var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFastForward = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44922 9.38086C1.68945 9.38086 1.88867 9.30469 2.12305 9.16406L8.09375 5.64844C8.41602 5.46094 8.5918 5.25 8.65625 5.00391V8.37891C8.65625 9.0293 9.04297 9.38086 9.5 9.38086C9.74023 9.38086 9.93945 9.30469 10.1738 9.16406L16.1504 5.64844C16.5605 5.40234 16.7422 5.11523 16.7422 4.77539C16.7422 4.44141 16.5605 4.1543 16.1504 3.9082L10.1738 0.392578C9.93945 0.251953 9.74023 0.175781 9.5 0.175781C9.04297 0.175781 8.65625 0.527344 8.65625 1.17773V4.55273C8.5918 4.30664 8.41602 4.0957 8.09375 3.9082L2.12305 0.392578C1.88281 0.251953 1.68945 0.175781 1.44922 0.175781C0.992188 0.175781 0.605469 0.527344 0.605469 1.17773V8.37891C0.605469 9.0293 0.992188 9.38086 1.44922 9.38086Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFastForward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-fast-forward.705a10e3a6c0e1cde3656f3277b248d7.svg";